const PIXEL_ID = '912972034872110'
let initialized = false

function getFbq(): ((...args: any[]) => void) | null {
  return (window as any).fbq || null
}

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  try {
    // Set up fbq queue before script loads
    const w = window as any
    if (!w.fbq) {
      const q: any[] = []
      w.fbq = function (...args: any[]) {
        q.push(args)
      }
      w.fbq.queue = q
      w.fbq.loaded = true
      w.fbq.version = '2.0'
      w._fbq = w.fbq
    }

    // Load the Facebook Pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'

    if (document.head) {
      document.head.appendChild(script)
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        document.head.appendChild(script)
      })
    }

    // Initialize pixel
    w.fbq('init', PIXEL_ID)
  } catch (e) {
    console.warn('Meta Pixel init failed:', e)
  }
}

export function trackPageView() {
  try {
    const fbq = getFbq()
    if (fbq) fbq('track', 'PageView')
  } catch (e) {
    console.warn('Meta Pixel PageView failed:', e)
  }
}

export function trackAddToCart() {
  try {
    const fbq = getFbq()
    if (fbq) {
      fbq('track', 'AddToCart', {
        content_name: 'Menús Express Ebook',
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
      })
    }
  } catch (e) {
    console.warn('Meta Pixel AddToCart failed:', e)
  }
}
